module.exports = __webpack_public_path__ + "img/00052.88f536ef.webp";